import { Person } from '@core/data-access/models/person.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreateSavedTicketHoldersRequest } from '../models/saved-ticket-holders-api.model';
import {
  SetCreatedSavedTicketHolderPersonsBeforeSaveOrder,
  SetSavedTicketHolderFormFieldsWithoutSaving,
  SetSavedTicketHolderQuestionnaireFormFieldsWithoutSaving,
  SetSavedTicketHolders,
  SetUpdatedTicketHolder,
  UpdateSavedTicketHolder
} from '../models/saved-ticket-holders.store.model';

export const SavedTicketHolderActions = createActionGroup({
  source: 'Saved ticket holder',
  events: {
    'Set saved ticket holders': (savedTicketHolders: SetSavedTicketHolders) => ({
      savedTicketHolders
    }),
    'Set created saved ticket holder persons before save order':
      props<SetCreatedSavedTicketHolderPersonsBeforeSaveOrder>(),
    'Add created ticket holders': (createdTicketHolders: SetSavedTicketHolders) => ({
      createdTicketHolders
    }),
    'Add created ticket holders before save order': (createdTicketHolders: SetSavedTicketHolders) => ({
      createdTicketHolders
    }),
    'Set updated ticket holder': props<SetUpdatedTicketHolder>(),
    'Remove deleted ticket holder': (person: Person) => ({ person }),
    'Reset reducer': emptyProps()
  }
});

export const SavedTicketHolderFormActions = createActionGroup({
  source: 'Saved ticket holder form',
  events: {
    'Update saved ticket holder': props<UpdateSavedTicketHolder>(),
    'Set saved ticket holder form fields without saving': props<SetSavedTicketHolderFormFieldsWithoutSaving>(),
    'Set saved ticket holder questionnaire form fields without saving':
      props<SetSavedTicketHolderQuestionnaireFormFieldsWithoutSaving>(),
    'Reset saved ticket holders unsaved form fields': emptyProps(),
    'Delete saved ticket holder': (person: Person) => ({ person })
  }
});

export const CreateTicketHolderFormActions = createActionGroup({
  source: 'Create ticket holder form',
  events: {
    'Create ticket holder': (createSavedTicketHoldersRequest: CreateSavedTicketHoldersRequest) => ({
      createSavedTicketHoldersRequest
    })
  }
});
